import React from 'react';
import { PanViewer } from 'react-image-pan-zoom-rotate';
import styles from './DocumentsPanViewer.scss';

type DocumentsPanViewerProps = {
  url: string;
  zoomLevel: number;
  rotation: number;
  alt: string;
  panPosition: { dx: number; dy: number };
  setPanPosition: (dx: number, dy: number) => void;
  handleImageLoad: (containerWidth: number, containerHeight: number, imgWidth: number, imgHeight: number) => void;
};

function DocumentsPanViewer(props: DocumentsPanViewerProps) {
  const { url, zoomLevel, rotation, alt, panPosition, setPanPosition, handleImageLoad } = props;

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const container = document.getElementById('image-container');

    if (!container) {
      return null;
    }

    const img = e.currentTarget;
    const { clientWidth: imgWidth, clientHeight: imgHeight } = img;
    const { clientWidth: containerWidth, clientHeight: containerHeight } = container;

    handleImageLoad(containerWidth, containerHeight, imgWidth, imgHeight);
  };

  return (
    <div className={styles.imageContainer} id="image-container">
      <PanViewer
        key={`${panPosition.dx}-${panPosition.dy}-${zoomLevel}`}
        zoom={zoomLevel}
        pandx={panPosition.dx}
        pandy={panPosition.dy}
        onPan={setPanPosition}
        rotation={rotation}
      >
        <img
          style={{
            transform: `rotate(${rotation * 90}deg)`,
            width: '100%',
          }}
          onLoad={onImageLoad}
          alt={alt}
          src={url}
        />
      </PanViewer>
    </div>
  );
}

export default DocumentsPanViewer;
